export default __webpack_public_path__ + "static/media/img8.7585c3b8.jpg";